import React from 'react'

export const Blockquote = (props) => (
    <blockquote {...props} className="p-6 rounded bg-accent dark:bg-accent-dark border border-light dark:border-dark" />
)
